exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nmain[data-v-58e3b234] {\n    height: 100%;\n}\n@media screen and (max-width: 575px) {\n.forgotPasswordForm[data-v-58e3b234] {\n        padding-bottom: 42px;\n}\n}\n", ""]);

// exports
